export const parseJwt = (token) => {
  try {
    const base64Payload = token.split('.')[1];
    return JSON.parse(atob(base64Payload));
  } catch (error) {
    return null;
  }
};

export const getToken = () => localStorage.getItem('token');

export const getUserRoleFromToken = (token) => {
  const payload = parseJwt(token);
  if (!payload) {
    return null;
  }

  return payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
};

export const clearToken = () => {
  localStorage.removeItem('token');
};

export const redirectToLogin = () => {
  clearToken();
  window.location.hash = '#/';
};
